import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { API } from "../../../app.config";
import { Cia, ListaPaginada } from "../../../model";

@Injectable({
    providedIn: "root",
})
export class CiaService {
    constructor(private http: HttpClient) {}

    getAll(valor: string = ""): Observable<ListaPaginada<Cia>> {
        return this.http.get<ListaPaginada<Cia>>(`${API}/api/ciarodoviaria/list?q=${valor}`);
    }

    getById(id: number): Observable<ListaPaginada<Cia>> {
        return this.http.get<ListaPaginada<Cia>>(`${API}/api/ciarodoviaria/${id}`);
    }

    post(cia: Cia): Observable<Cia> {
        return this.http.post<Cia>(`${API}/api/ciarodoviaria`, cia);
    }

    put(cia: Cia): Observable<Cia> {
        return this.http.put<Cia>(`${API}/api/ciarodoviaria/${cia.Id}`, cia);
    }
}
